import React from 'react';
import {Image} from "../../../../core/components/image/image";
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {observer} from 'mobx-react';

export const CompetitorPlayersStatsModulePlayerStatsHeatMap = observer(({controller}) => {
  const {state} = controller;
  const {selectedPlayer, shouldRenderHeatMap} = state;

  const heatMapImageProps = {
    className: classNames(styles.player_stats_heat_map_container),
    src: selectedPlayer.heatMap,
  }

  return shouldRenderHeatMap ? <Image {...heatMapImageProps}/> : null
})
